import React from 'react'
import { ColumnMapping } from 'api'
import { SelectboxField } from 'view/components/options'
import * as constants from 'view/styles/constants'
import { getAllHeadings } from '../model'
import { ColumnMappingPanelProps } from './ColumnMappingPanel'

export const ColumnMappingHeaderSelectbox: React.FunctionComponent<ColumnMappingPanelProps<ColumnMapping>> = props => {
  const { fieldTitle, fieldName, columnMapping, parseResult, onUpdate } = props

  const handleUpdateHeading = (heading: string) => onUpdate({ ...columnMapping, heading }, fieldName)

  return (
    <SelectboxField
      label={fieldTitle}
      labelPosition={constants.LabelPosition.Left}
      optionKeys={getAllHeadings(parseResult.rows)}
      value={columnMapping.heading}
      validationField={fieldTitle}
      validationIssues={parseResult.issues}
      canClear={true}
      onUpdate={handleUpdateHeading}
    />
  )
}
